import { render } from "./NotificationsSettingsModal.vue?vue&type=template&id=0e57f6a2&ts=true"
import script from "./NotificationsSettingsModal.vue?vue&type=script&lang=ts"
export * from "./NotificationsSettingsModal.vue?vue&type=script&lang=ts"

import "./NotificationsSettingsModal.vue?vue&type=style&index=0&id=0e57f6a2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__